/** 家属端首页展示数据（一期 mock，后续对接护工/评价 API） */

export const HOME_STATS = [
  { label: "持证护工", value: "320+", unit: "" },
  { label: "好评率", value: "98.6", unit: "%" },
  { label: "累计服务", value: "1.2", unit: "万+" },
];

export const FEATURED_CAREGIVERS = [
  {
    id: 1,
    name: "王秀英",
    level: "金牌护工",
    levelColor: "bg-amber-500",
    avatarBg: "from-emerald-400 to-teal-500",
    rating: 4.9,
    orders: 1286,
    experience: "8年",
    hospital: "市一医院常驻",
    tags: ["术后护理", "翻身拍背", "鼻饲照护"],
    intro: "擅长神经外科、骨科术后陪护，耐心细致，家属好评率 99%。",
  },
  {
    id: 2,
    name: "李芳",
    level: "银牌护工",
    levelColor: "bg-slate-400",
    avatarBg: "from-blue-400 to-indigo-500",
    rating: 4.8,
    orders: 892,
    experience: "5年",
    hospital: "华山医院常驻",
    tags: ["老年陪护", "糖尿病照护", "康复协助"],
    intro: "内分泌、老年病科经验丰富，沟通温和，擅长慢病老人日常照料。",
  },
  {
    id: 3,
    name: "张建国",
    level: "金牌护工",
    levelColor: "bg-amber-500",
    avatarBg: "from-orange-400 to-amber-500",
    rating: 5.0,
    orders: 2103,
    experience: "12年",
    hospital: "瑞金医院常驻",
    tags: ["重症监护", "气管切开", "24h值守"],
    intro: "ICU 转出患者陪护专家，夜班稳定，应急处理经验丰富。",
  },
  {
    id: 4,
    name: "陈美玲",
    level: "金牌护工",
    levelColor: "bg-amber-500",
    avatarBg: "from-pink-400 to-rose-500",
    rating: 4.9,
    orders: 1567,
    experience: "9年",
    hospital: "六院骨科常驻",
    tags: ["骨科康复", "助行训练", "伤口观察"],
    intro: "骨科康复期陪护能手，协助下床活动与康复训练，获多次家属锦旗。",
  },
];

export const USER_REVIEWS = [
  {
    id: 1,
    user: "李女士",
    hospital: "市一医院 · 心内科",
    rating: 5,
    date: "2026-06-20",
    content: "王阿姨非常专业，每天拍照反馈老人情况，翻身、擦身都很到位，我们全家很放心。",
    caregiver: "王秀英",
  },
  {
    id: 2,
    user: "张先生",
    hospital: "华山医院 · 内分泌科",
    rating: 5,
    date: "2026-06-18",
    content: "李护工对老爷子很有耐心，血糖监测和饮食都安排得很好，调度响应也很快。",
    caregiver: "李芳",
  },
  {
    id: 3,
    user: "赵女士",
    hospital: "瑞金医院 · ICU转出",
    rating: 5,
    date: "2026-06-15",
    content: "张师傅夜班特别靠谱，气管护理专业，有问题随时沟通，强烈推荐。",
    caregiver: "张建国",
  },
];

export const SERVICE_HIGHLIGHTS = [
  {
    title: "人工调度",
    desc: "15 分钟响应",
    icon: "dispatch",
    color: "bg-blue-50 text-family-blue",
  },
  {
    title: "实拍打卡",
    desc: "全程可追踪",
    icon: "camera",
    color: "bg-teal-50 text-caregiver-green",
  },
  {
    title: "持证上岗",
    desc: "KYC 严格审核",
    icon: "cert",
    color: "bg-amber-50 text-amber-600",
  },
];
